import React from 'react';
import axios from 'axios';
import CardSummary from '@/components/molecules/CardSummary';
import { SERVICES } from '@/configs';
import { getLocalStorage } from '@/utils/storages';
import { useQuery } from '@tanstack/react-query';
import moment from 'moment';
import styles from './FeedbackSummary.module.scss';

type FeedbackSummaryAPI = {
  nps_count?: number;
  nps_avg?: number;
  feedback_count?: number;
  feedback_avg?: number;
}

type FeedbackSummary = {
  startDate?: string;
  endDate?: string;
  className?: string;
}

const fetchFeedbackSummary = async (startDate?: string, endDate?: string, status?: string):
  Promise<FeedbackSummaryAPI> => {
  const payload = {
    endDate,
    startDate,
  };

  const options = {
    method: 'GET',
    url: SERVICES.FEEDBACK + '/summary',
    params: payload,
    headers: {
      'Authorization': `Bearer ${getLocalStorage('access_token')}`,
    }
  };

  const res = await axios.request(options);
  return res.data?.data[0];
};

const FeedbackSummary: React.FC<FeedbackSummary> = ({ startDate, endDate }) => {
  const statusActive = 'aktif';
  const statusInactive = 'tidak aktif';

  const { data } = useQuery({
    queryKey: ['feedback-summary', startDate, endDate, statusActive],
    queryFn: () => fetchFeedbackSummary(startDate, endDate, statusActive),
  });
 
  return (
    <div className={styles['feedback-summary']}>
      <div className={styles['feedback-summary__item']}>
        <div className={styles['feedback-summary__item--title']}>
          NPS (Net Promoter Score)
        </div>
        <div className={styles['feedback-summary__item--data']} data-testid="card-summary">
          <CardSummary border={false} description="Menampilkan total respon NPS yang diterima dari pengguna."
            title="Total NPS" value={data?.nps_count} variant="success" />
          <CardSummary border={false} description="Menampilkan Net Promoter Score (NPS), yaitu ukuran loyalitas pelanggan dan kesediaan mereka untuk merekomendasikan produk atau layanan. Nilai NPS dapat berkisar di antara -100 s/d 100."
            title="NPS" value={data?.nps_avg ? Number(data.nps_avg).toFixed(1) : 0}
            tooltip="bottom_center" variant="success" />
        </div>
      </div>
      <div className={styles['feedback-summary__item']}>
        <div className={styles['feedback-summary__item--title']}>
          Rating Apps
        </div>
        <div className={styles['feedback-summary__item--data']} data-testid="card-summary">
          <CardSummary border={false} description="Menampilkan total respon rating yang diterima dari pengguna, termasuk penilaian positif, netral, dan negatif."
            title="Total Rating" value={data?.feedback_count} variant="success" />
          <CardSummary border={false} description="Menampilkan rata-rata skor rating yang diberikan oleh pengguna."
            title="Rata-rata Rating" value={data?.feedback_avg ? Number(data.feedback_avg).toFixed(1) : 0} variant="success" />
        </div>
      </div>
    </div>
  );
};

export default React.memo(FeedbackSummary);
